import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSearchModel, IGlobalSearchModelData } from '@pflegix/types';
import { Subject } from 'rxjs';

const GLOBAL_SEARCH_MODEL_TO_URL_MAPPING: Record<GlobalSearchModel, string> = {
  BusinessPartner: 'business-partner-center/',
  User: 'users/',
  Lead: 'leads/',
  Task: 'task/taskView/',
  Post: 'post/postEdit/',
  Application: 'application/applicationEdit/',
  Order: 'order/orderEdit/',
  Documentation: 'documentation/documentationsEdit/',
};

@Injectable({ providedIn: 'root' })
export class GlobalSearchEventService {
  private selectedModel = new Subject<IGlobalSearchModelData>();

  public selectedModel$ = this.selectedModel.asObservable();

  private readonly router = inject(Router);

  public selectModel(model: IGlobalSearchModelData): void {
    this.selectedModel.next(model);
  }

  public getUrl(modelResult: IGlobalSearchModelData): string {
    return this.router.serializeUrl(
      this.router.createUrlTree([GLOBAL_SEARCH_MODEL_TO_URL_MAPPING[modelResult.model], modelResult._id])
    );
  }
}
